module.exports = __webpack_public_path__ + "bi.svg?d0615c777a4d8ada254341565c49bcd5";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/bi.svg
// module id = 1002
// module chunks = 0